import React from "react"
import tw, { styled } from "twin.macro"

import { SlideProps } from "."

import Container from "../components/container"
import NextPageButton from "../components/nextPageButton"
import SlideSection from "../components/slideSection"
import NextPageContainer from "../components/nextPageContainer"
import IconCountry from "../icons/iconCountry"

const Columns = styled.div`
  ${tw`flex flex-col lg:flex-row items-center justify-center w-full`}
`

const MediumThreeQuarters = styled.div`
@media (max-width: 768px) {
  width: 70vw;
}
  ${tw`lg:w-3/5 flex flex-col items-center justify-center`}
`

const MediumOneQuarter = styled.div`
  width: 15% ${tw`lg:w-2/6 flex flex-col items-end justify-center`};
`

const Instructions = styled.p`
  ${tw`hidden md:block w-64 text-center  text-sm mb-6`}
`

const InstructionsSmall = styled.p`
  ${tw`md:hidden w-64 text-center  text-sm mb-6`}
`

const CountrySlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {
  return (
    <SlideSection autoHeightResponsive>
      <div css={[tw`flex flex-col justify-center items-center`]}>
        <Container>
          <Columns>
            <MediumThreeQuarters>
              <IconCountry />
            </MediumThreeQuarters>
            <MediumOneQuarter>
              <TextQuarter css={[
                tw`mt-6`
              ]}>
                You won’t be restricted to living in a main centre. The trucking network spans the country.
              </TextQuarter>
            </MediumOneQuarter>
            <SmallOneQuarter></SmallOneQuarter>
          </Columns>
        </Container>
        <NextPageContainer>
          <NextPageButton
            onClick={nextButtonClicked}
            label=""
          />
        </NextPageContainer>
      </div>
    </SlideSection>
  )
}

const TitleWrapper = styled.div`
  ${tw`flex flex-col items-center justify-center mt-24 md:mt-0`}
`
const TextQuarter = styled.div`
  font-family: Interstate; font-size: 26px; line-height: 31.2px; font-weight: 300; letter-spacing: 0.41px;
  @media (max-width: 768px) {
    font-size: 22px; 
    line-height: 26px;
    width: 76vw;
  }
  ${tw`flex flex-col flex-wrap flex-row text-center justify-center`}
`
const SmallOneQuarter = styled.div`
  ${tw`lg:w-1/12 flex flex-col items-center justify-center`}
`

export default CountrySlide
